<template>
  <index />
</template>

<script setup>
import index from "~/components/about/index.vue";
</script>
